import { render, staticRenderFns } from "./AddLead.vue?vue&type=template&id=285e2ba9&scoped=true"
import script from "./AddLead.vue?vue&type=script&lang=js"
export * from "./AddLead.vue?vue&type=script&lang=js"
import style0 from "./AddLead.vue?vue&type=style&index=0&id=285e2ba9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e2ba9",
  null
  
)

export default component.exports